<bn-web-ui-toastr-component />
<router-outlet />
@for (src of preloadImages; track src) {
  <img
    class="bn-preload d-block"
    loading="eager"
    width="0"
    [src]="src" />
}
